import { Component } from '@angular/core';

@Component({
  selector: 'app-warning-user-import',
  styles: ['.wrapper { align-items: center }'],
  template: `
    <div fxLayout="row" fxLayoutWrap="wrap">
      <div fxFlex="100">
        <mat-card>
          <mat-card-content>
            <!-- Row -->
            <div class="wrapper d-flex no-block">
              <!-- column -->
              <div class="m-r-10 no-shrink">
                <button mat-fab color="warn" mat-card-icon class="shadow-none bg-danger">
                  <mat-icon>warning</mat-icon>
                </button>
              </div>
              <!-- column -->
              <div>
                <h3 class="m-0">Se ignorarán los registros que tengan nombre o código de otro usuario existente</h3>
              </div>
            </div>
          </mat-card-content>
        </mat-card>
      </div>
    </div>
  `,
})
export class WarningUserImportMessageComponent {
  constructor() {}
}
